<template>
  <div
    class="w-100 tw-flex item-c cursor-pointer tw-p-4 tw-overflow-hidden"
    @click="handleToProductDetail(item)"
  >
    <img
      v-if="isShowIcon"
      class="tw-hidden lg:tw-block tw-w-6 tw-h-6 tw-flex-none tw-mr-2.5"
      :src="item.icon || '/icon-se.png'"
      alt=""
    />
    <div class="tw-flex-1">
      <span
        class="fontstylewrapmore-1 item-title font-weight-bold tw-hover:text-[#4077F8]"
        style="font-size: 14px; color: #333"
        >{{ getTitle(item) }}</span
      >
      <div
        v-if="isShowDesc"
        class="fontstylewrapmore-1 tw-mt-1.5 tw-overflow-hidden"
        style="font-size: 13px; color: #666"
      >
        {{ getDesc(item) }}
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "SelectItem",
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    isShowIcon: {
      type: Boolean,
      default: true,
    },
    isShowDesc: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    getTitle(item) {
      return item.title || item.name;
    },
    getDesc(item) {
      return item.intro || "暂无描述";
    },
    handleToProductDetail(child) {
      this.$emit("onSelect", child);
    },
  },
};
</script>

<style scoped lang="scss">
.item-c:hover {
  border-radius: 6px;
  box-shadow: 0 0 10px 0 rgba(64, 119, 248, 0.2);

  .item-title {
    color: #4077f8 !important;
  }
}
</style>
